var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"jsp-title"},[_vm._v(_vm._s(_vm.facilityName))])}
var staticRenderFns = []

export { render, staticRenderFns }